// Module
var code = `<dx-button *ngIf="this.visible" type="default" stylingMode="contained" (onClick)="this.selectionOptionsPopUpService.popupControl.toggleVisibility()"> <i class="fa-solid fa-list"></i> </dx-button> `;
// Exports
export default code;